import { api } from '../api';

export const PLACEHOLDERS_ENDPOINTS = Object.freeze({
  getMultiple: (names: string[]) => api.get(`placeholders/${names.toString()}`),
});
